import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  //mode:'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/love-with-your-phone',
      name: 'love-with-your-phone',
      component: () => import('./views/jono-and-raj.vue')
    },
    {
      path: '/valora-music',
      name: 'valora-music',
      component: () => import('./views/valora.vue')
    },
    {
      path: '/jesse-if-i-had-the-words',
      name: 'jesse-if-i-had-the-words',
      component: () => import('./views/jesse-if-i-had-the-words.vue')
    },
    {
      path: '/layers-of-joy',
      name: 'layers-of-joy',
      component: () => import('./views/layers-of-joy.vue')
    },
    {
      path: '/era-of-women',
      name: 'era-of-women',
      component: () => import('./views/era-of-women.vue')
    },
    {
      path: '/john-swardson-the-storm',
      name: 'john-swardson-the-storm',
      component: () => import('./views/john-swardson-the-storm.vue')
    }
  ]
})
